import { Tooltip, TooltipProps } from "@shopify/polaris"
import classNames from "classnames"
import React from "react"

import { useShowTooltip } from "../../hooks/useShowTooltip"

export interface ProTooltipProps extends Omit<TooltipProps, "content"> {
  content?: React.ReactNode
  className?: string
  truncate?: boolean
}
export const ProTooltip = (props: ProTooltipProps) => {
  const { content, children, className, truncate = false } = props
  const { showTooltip, ref } = useShowTooltip({
    content,
    truncate,
  })

  return (
    <Tooltip
      content={content}
      active={showTooltip}
      dismissOnMouseOut={props.dismissOnMouseOut ?? true}
      {...props}
    >
      <div
        className={classNames({ truncate: truncate }, className)}
        ref={ref}
        // onMouseEnter={(e) => {
        //   if (!e.target) return
        //   const show =
        //     (e.target as any)!.scrollWidth > (e.target as any)!.offsetWidth
        //   setShowTooltip(show)
        // }}
      >
        {children}
      </div>
    </Tooltip>
  )
}
